import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/utils/modal';
import Header from './header';
import Body from './body';
import './styles.scss';

const propTypes = {
  handleClose: PropTypes.func,
};

const defaultProps = {
  handleClose: () => {},
};

const Transcript = ({ handleClose }) => {
  return (
    <Modal onClose={handleClose} className="transcript-modal">
      <Header />
      <Body />
    </Modal>
  );
};

Transcript.propTypes = propTypes;
Transcript.defaultProps = defaultProps;

const areEqual = (prevProps, nextProps) => {
  return prevProps.handleClose === nextProps.handleClose;
};

export default React.memo(Transcript, areEqual);
